import ProductAddDialog from 'components/private/Modals/operation/ProductSearch/ProductAddDialog';
import ProductEditDialog from 'components/private/Modals/operation/ProductSearch/ProductEditDialog';
import ProductReportsDialog from 'components/private/Modals/operation/ProductSearch/ProductReportsDialog';
import useProductSearch from 'components/private/Modals/operation/ProductSearch/useProductSearch';
import DeleteModal from 'components/shared/DeleteModal/DeleteModal';
import PageSpinner from 'components/shared/pageSpinner/PageSpinner';
import ApiPaginateTable from 'components/shared/Table/ApiPaginateTable';
import useProductSearchTableColumns from 'hooks/operation/useProductSearchTableColumns';
import { useCallback, useRef, useState } from 'react';

const ProductList = ({
  operationGuid,
  state,
  voucherType,
  reportDisabled = false,
  operationType, // "entry" | "departure" | "transfer"
}) => {
  const [pageSize, setPageSize] = useState('100');

  const search = useProductSearch({
    operationGuid,
    state,
    voucherType,
    features: {
      reports: !reportDisabled,
      excelImport: false,
      packEdit: true,
    },
  });

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteChosenProductSearch, setDeleteChosenProductSearch] = useState(
    {},
  );

  const tableRef = useRef(null);

  const deleteItem = useCallback(
    row => () => {
      setDeleteChosenProductSearch(row);
      setIsDeleteModalOpen(true);
    },
    [],
  );

  const closeDeleteModal = () => setIsDeleteModalOpen(false);

  const deleteHandle = async guid => {
    const ok = await search.handleDelete(guid);
    if (ok) closeDeleteModal();
  };

  const editItem = useCallback(
    row => () => {
      search.openEdit(row);
    },
    [search.openEdit],
  );

  const reportItem = useCallback(
    row => () => {
      search.openReports(row);
    },
    [search.openReports],
  );

  const [columnsData] = useProductSearchTableColumns(
    deleteItem,
    editItem,
    reportItem,
    tableRef,
    { reportDisabled },
  );

  return (
    <>
      {search.initialLoading ? (
        <PageSpinner loading />
      ) : (
        <ApiPaginateTable
          columns={columnsData}
          rowsData={search.orderedProductList[search.page]}
          rows={search.orderedProductList[search.page]}
          pageSize={pageSize}
          disableSelection
          isLoading={search.loading}
          addLable="افزودن محصول"
          onAddClick={() => search.openAdd()}
          setPageSize={val => setPageSize(val)}
          apiRef={tableRef}
          onPageChange={pageNumber => search.loadProducts({ pageNumber })}
          page={search.page}
          countPages={search.pageCount}
          handleSearchApi={search.setListTerm}
        />
      )}

      <DeleteModal
        open={isDeleteModalOpen}
        handleClose={closeDeleteModal}
        locationId={deleteChosenProductSearch.guid}
        title={deleteChosenProductSearch.title}
        deleteLoading={search.loading}
        onDelete={deleteHandle}
      />

      <ProductAddDialog
        open={search.add.open}
        onClose={search.add.onClose}
        loading={search.loading}
        step={search.add.step}
        onBackToSearch={() => search.add.setStep('search')}
        searchTerm={search.add.searchTerm}
        onSearchTermChange={search.add.setSearchTerm}
        searchResults={search.add.searchResults}
        searchLoading={search.add.searchLoading}
        packages={search.add.packages}
        selectedProduct={search.add.selectedProduct}
        selectedPack={search.add.selectedPack}
        quantity={search.add.quantity}
        onQuantityChange={search.add.setQuantity}
        onSelectProduct={search.add.onSelectProduct}
        onSelectPack={search.add.onSelectPack}
        onInsert={search.add.onInsert}
        operationType={operationType}
      />

      <ProductEditDialog
        open={Boolean(search.edit.item)}
        onClose={search.edit.onClose}
        loading={search.loading}
        canEditPack={search.canEditPack}
        qty={search.edit.qty}
        onQtyChange={search.edit.setQty}
        packOptions={search.edit.packOptions}
        onSave={search.edit.onSave}
        onSavePack={search.edit.onSavePack}
      />

      {!reportDisabled ? (
        <ProductReportsDialog
          open={Boolean(search.reports.item)}
          onClose={search.reports.onClose}
          loading={search.loading}
          canMutateReports={search.canMutateReports}
          step={search.reports.step}
          reports={search.reports.list}
          form={search.reports.form}
          onFormChange={patch =>
            search.reports.setForm(prev => ({ ...prev, ...patch }))
          }
          editing={search.reports.editing}
          onStartCreate={search.reports.onStartCreate}
          onStartEdit={search.reports.onStartEdit}
          onBackToList={search.reports.onBackToList}
          onSave={search.reports.onSave}
          onDelete={search.reports.onDelete}
        />
      ) : null}
    </>
  );
};

export default ProductList;
